module.exports = __webpack_public_path__ + "img/页面图片修改2-2.f3a9e85e.png";